<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <rp-icon icon="rp-partes-diarias-blue-filled" class="mr-2"/> <span>{{$t('menu.daily_parts_management')}}</span>
      </h1>

      <v-row>
        <v-col cols="12" md="auto">
          <v-icon color="warning">
            mdi-check-circle
          </v-icon><v-icon class="ml-2" color="secondary" small>mdi-forward</v-icon>
          <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.mark_read')}}</span>
        </v-col>
        <v-col cols="12" md="auto">
          <rp-icon
              icon="rp-eye-blue-filled"
              class="mb-n2"
          /><v-icon class="ml-2" color="secondary" small>mdi-forward</v-icon>
          <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.visualize')}}</span>
        </v-col>
        <v-col cols="12" md="auto">
          <v-icon color="success">
            mdi-check
          </v-icon><v-icon class="ml-2" color="secondary" small>mdi-forward</v-icon>
          <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.approve')}}</span>          
        </v-col>
        <v-col cols="12" md="auto">
          <v-icon color="error">
            mdi-delete
          </v-icon><v-icon class="ml-2" color="secondary" small>mdi-forward</v-icon>
          <span :class="this.$root.$vuetify.theme.isDark ? 'primary--text text-caption' : 'primary--text text-caption'">{{$t('globals.remove')}}</span>
          
        </v-col>
      </v-row>

      <div style="position:relative">
        <v-container>
          <v-speed-dial
            absolute
            v-model="speedDial"
            top
            right
            direction="bottom"
            :open-on-hover="true"
          >
            <template v-slot:activator>
              <v-tooltip right color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    v-model="speedDial"
                    color="primary"
                    dark
                    x-large
                    fab
                  >
                    <v-icon v-if="speedDial">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{$t('globals.options')}}</span>
              </v-tooltip>
            </template>
            <v-tooltip right color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="success"
                  large
                  @click="modalChooseData = true"
                >
                  <v-icon>mdi-paperclip</v-icon>
                </v-btn>
              </template>
              <span>{{$t('globals.export')}}</span>
            </v-tooltip>
            <v-tooltip right color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="info"
                  large
                  @click="searching = true"
                >
                  <v-icon>mdi-filter</v-icon>
                </v-btn>
              </template>
              <span>{{$t('globals.search')}}</span>
            </v-tooltip>
            <v-tooltip right color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="secondary"
                  large
                  :to="'/' + $session.get('domain') + '/admin/diaries/create'"
                  v-if="$root.session.hasPermission(['super', 'diaries.create'])"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{$t('globals.register')}}</span>
            </v-tooltip>
          </v-speed-dial>
        </v-container>

        <v-data-table
          :item-class= "row_classes"   
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :loading="loading"
          :footer-props="tableFooter"
          :options.sync="options"
          :expanded.sync="expanded"
          show-expand
          :class="this.$root.$vuetify.theme.isDark ? 'secondary mt-16' : 'mt-16'"
          locale="pt-pt"
        >
        <template v-slot:item.read="{item}">
          <Tooltip
            class="my-4 mr-4"
            color="success"
            :text="$t('globals.mark_read')"
            top
            v-if="item.readed == false"
          >
            <v-icon color="warning" @click="markDiaryReaded(item)">
              mdi-check-circle
            </v-icon>
          </Tooltip> 

          <Tooltip
            class="my-4 mr-4"
            color="red"
            text="Diária rejeitada (Clique para saber mais)"
            top
            v-if="item.rejected == true"
          >
            <v-icon color="red" @click="showRejectedHistory(item)">
              mdi-hospital-box
            </v-icon>
          </Tooltip> 
          
        </template>
        
          <template v-slot:item.work="{ item }">
            {{ item.work_object.code }} : {{ item.work_object.name }}
          </template>

          <template v-slot:item.status="{ item }">
              <v-img style="margin: auto; display:block;" v-if="item.status == 'FINISHED_APPROVAL'" src="@/assets/icons/app/certinho.png" max-width="20px"></v-img>
              <v-img style="margin: auto; display:block;" v-else src="@/assets/icons/app/certinho_unchecked.png" max-width="20px"></v-img>
          </template>

          <template v-slot:item.date="{ item }">
            {{getTableDate(item.date)}}
          </template>

          <template v-slot:item.actions="{item}">
            <v-row>
              <v-col cols="12" md="auto">
                <IconView
                  @click="viewDiary(item)"
                />

                <Tooltip
                  color="success"
                  :text="$t('globals.preview')"
                  top
                >
                  <v-btn icon color="success" @click="previewDiary.id = item.id; previewDiary.show=true;">
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                </Tooltip>
                
                <v-btn icon
                    v-for="approval of getPossibleApprovals(item)"
                    v-bind:key="approval"
                    @click="confirmApprove(item, approval)">
                  <v-icon
                    small
                    color="success"
                  >
                    mdi-check
                  </v-icon>
                </v-btn>
                
                <IconDownload
                  :text="$t('diaries.image_download')"
                  v-if="item.files.length > 0"
                  @click="downloadImages(item)"
                />
                
                <IconRemove
                  v-if="$root.session.hasPermission(['super', 'diaries.delete']) && item.status != 'FINISHED_APPROVAL'"
                  @on-submit="deleteDiary(item)"
                />
              </v-col>
            </v-row>
          </template>
          <!-- EXPANDABLE ROW -->
          <template v-slot:expanded-item="{ item }">
            
              <td colspan="4">
                <v-row>
                  <v-card
                    elevation="10"
                    color="#009688"
                    dark
                    :width="width"
                    class="mt-6 mb-4 ml-4"
                    height="200"
                  >
                  <v-row>
                    <v-card-title>
                      <v-icon
                        large
                        left
                      >
                        mdi-timer
                      </v-icon>
                      <span class="text-h6 font-weight-light">{{$t('diaries.creation')}}</span>
                    </v-card-title>
                  </v-row>

                    <v-card-text class="text-caption font-weight-bold">
                      {{$t('diaries.created_at')}}: <p class="font-weight-light">{{getDateHour(item.created_at)}}h</p>
                    </v-card-text>
                    

                    <v-card-actions class="mt-n1">
                      <v-list-item class="grow">     
                        <v-list-item-avatar color="grey darken-3" >
                          <v-icon >
                            mdi-account
                          </v-icon>
                        </v-list-item-avatar>
                  
                        <v-list-item-content>
                          <v-list-item-title  style="float:right;">{{item.user_created != null ? item.user_created.name : '-'}}</v-list-item-title>
                        </v-list-item-content>
                        
                      
                      </v-list-item>
                    </v-card-actions>
                  </v-card>
                  <v-card
                    elevation="10"
                    color="warning"
                    dark
                    :width="width"
                    class="mt-6 mb-4 ml-4"
                    height="200"
                  >
                  <v-row>
                    <v-card-title>
                      <v-icon
                        large
                        left
                      >
                        mdi-pencil
                      </v-icon>
                      <span class="text-h6 font-weight-light">{{$t('diaries.updates')}}</span>
                    </v-card-title>
                  </v-row>
                    <v-card-text class="text-caption font-weight-bold mt-n6">
                      {{$t('diaries.updated_at')}}: <p class="font-weight-light">{{getDateHour(item.updated_at)}}h</p>
                    </v-card-text>
                    <v-card-text class="text-caption font-weight-bold mt-n10">
                      {{$t('diaries.n_editions')}}: <p class="font-weight-light">{{item.editions_qty}}</p>
                    </v-card-text>

                    <v-card-actions :class="width > 150 ? 'mt-n10' : 'mt-n16 ml-6'">
                      <v-list-item class="grow">     
                        <v-list-item-avatar color="grey darken-3" >
                          <v-icon >
                            mdi-account
                          </v-icon>
                        </v-list-item-avatar>
                  
                        <v-list-item-content>
                          <v-list-item-title  style="float:right;">{{item.user_edited != null ? item.user_edited.name : '-'}}</v-list-item-title>
                        </v-list-item-content>
                        
                      
                      </v-list-item>
                    </v-card-actions>
                  </v-card>
                  <v-card
                    elevation="10"
                    color="secondary"
                    class="mt-6 mb-4 ml-4"
                    dark
                    :width="width"
                    height="200"
                  >
                  <v-row>
                    <v-card-title>
                      <v-icon
                        large
                        left
                      >
                        mdi-check-outline
                      </v-icon>
                      <span class="text-h6 font-weight-light">{{$t('diaries.approvals')}}</span>
                    </v-card-title>
                  </v-row>
                    <v-card-text class="text-caption font-weight-bold mt-n6">
                      {{$t('globals.state')}}: <p class="font-weight-light">{{status.find(i => i.id == item.status).name}}</p>
                    </v-card-text>
                    <v-card-text v-if="item.approvals.dto.approved_at != null" class="text-caption font-weight-bold mt-n10">
                      {{$t('globals.dto')}}: <p class="font-weight-light">{{item.approvals.dto.approved_at}}</p>
                    </v-card-text>
                    <v-card-actions :class="width > 150 ? 'mt-n10' : 'mt-n16 ml-6'">
                      <v-list-item class="grow" v-if="item.approval_history != null">     
                        <v-list-item-avatar color="grey darken-3" >
                          <v-icon >
                            mdi-account
                          </v-icon>
                        </v-list-item-avatar>
                  
                        <v-list-item-content>
                          <v-list-item-title  style="float:right;">{{ item.approval_history == null ? '-' : item.approval_history.name }}</v-list-item-title>
                        </v-list-item-content>
                        
                      
                      </v-list-item>
                    </v-card-actions>
                  </v-card>
                </v-row>
              </td>
              <td>
                <v-menu offset-y v-if="checkIfApproved(item)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    >
                    <v-icon
                      right
                      dark
                      class="mr-2"
                    >
                      mdi-download
                    </v-icon>
                      {{$t('globals.export')}}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(t, index) in exportItems"
                      :key="index"
                      @click="exportDiary(item, t.title)"
                    >
                      <v-list-item-title>{{ t.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
                
          </template>

          <!-- END EXPANDABLE ROW -->
        </v-data-table>
      </div>
      <v-navigation-drawer
          fixed
          right
          v-model="searching"
          hide-overlay
          width="520"
          class="pt-6"
        >
        <v-list>
          <v-list-item>
            <v-btn fab small color="secondary" @click="searching = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn absolute right small color="error" @click="resetDiaries">
              {{$t('globals.clean_fields')}}
            </v-btn>
          </v-list-item>
        </v-list>
        <v-list class="pt-10">
          <v-form @submit.prevent="searchDiaries">
            
            <v-list-item>
              <v-text-field
                v-model="filter.code"
                prepend-inner-icon="mdi-barcode"
                :label="$t('globals.code')"
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
               <v-select
                  v-model="filter.work_id"
                  :items="works"
                  :item-text="item => $t('globals.name') + ': ' + item.name + ' - ' + $t('globals.code') + ': '+ item.code"
                  item-value="id"
                  menu-props="auto"
                  :label="$t('globals.work')"
                  prepend-inner-icon="mdi-account-hard-hat"
                  clearable
                ></v-select>
            </v-list-item>

            <v-list-item>
               <v-select
                  v-model="filter.status"
                  :items="status"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :label="$t('globals.state')"
                  prepend-inner-icon="mdi-list-status"
                  clearable
                ></v-select>
            </v-list-item>

            <v-list-item v-if="!$root.session.hasRole(['encarregado'])">
               <v-select
                  v-model="filter.commissioner_id"
                  :items="commissioners"
                  :item-text="item => $t('globals.name') + ': ' + item.name + ' - ' + $t('globals.username') + ': '+ item.username"
                  item-value="id"
                  menu-props="auto"
                  :label="$t('globals.in_charge')"
                  prepend-inner-icon="mdi-account-hard-hat"
                  clearable
                ></v-select>
            </v-list-item>

            <v-list-item v-if="false">
               <v-select
                  v-model="filter.overseer_id"
                  :items="overseers"
                  :item-text="item => $t('globals.name') + ': ' + item.name + ' - ' + $t('globals.username') + ': '+ item.username"
                  item-value="id"
                  menu-props="auto"
                  :label="$t('globals.equipment_responsible')"
                  prepend-inner-icon="mdi-account-hard-hat"
                  clearable
                ></v-select>
            </v-list-item>

            <v-list-item v-if="!$root.session.hasRole(['dto'])">
               <v-select
                  v-model="filter.engineer_id"
                  :items="engineers"
                  :item-text="item => $t('globals.name') + ': ' + item.name + ' - ' + $t('globals.username') +': '+ item.username"
                  item-value="id"
                  menu-props="auto"
                  :label="$t('globals.engineer')"
                  prepend-inner-icon="mdi-account-tie"
                  clearable
                ></v-select>
            </v-list-item>

            <v-row
              class="mt-10"
              align="center"
              justify="space-around"
            >
            <v-btn
              color="primary"
              type="submit"
            >
              {{$t('globals.search')}}
            </v-btn>
            </v-row>
          </v-form>
        </v-list>
      </v-navigation-drawer>
      <DialogSuccess :opened="approved" @on-ok="approved = false" >
        {{$t('diaries.success')}}
      </DialogSuccess>
      <v-dialog
            v-model="modalChooseData"
            persistent            
            width="350px"
        >
        <ChooseData 
          @close="modalChooseData = false"
          @confirm="confirmExport"
          :secondOption="works"
          :secondOptionLabel="$t('globals.work')"/>
      </v-dialog>
      
    <ErrorSnackbar v-model="error.show" :message="error.message"/>
    <DialogConfirmation v-if="checkApproval.showModal"    
      :title="$t('diaries.confirm_action')" 
      type="info" 
      :opened="checkApproval.showModal"
      @on-submit="approve" 
      @on-cancel="checkApproval.showModal = false" >
      {{$t('diaries.are_you_sure')}}
    </DialogConfirmation>
    <RejectionHistory v-if="showRejected.show" :item="showRejected.item" @on-cancel="showRejected.show = false" :opened="showRejected.show" vid="rejected_history" :title="$t('diaries.rejection_story')"/>
    <Loader v-if="exportingDocument"></Loader>
    <v-dialog
      v-model="previewDiary.show"
      max-width="900px">
      <PreviewDiary @close="previewDiary.show=false" :id="previewDiary.id"/>
    </v-dialog>  
  </section>
</template>
<script>
import DialogSuccess from '@/components/ui/DialogSuccess.vue';
import DialogConfirmation from '@/components/ui/DialogConfirmation.vue';
import IconRemove from '@/components/ui/IconRemove.vue';
import IconView from '@/components/ui/IconView.vue';
import IconDownload from '@/components/ui/IconDownload.vue';
import Work from "@/api/Work.js";
import User from "@/api/User.js";
import Diary from "@/api/Diary.js";
import Export from "@/api/Export.js";
import dayjs from 'dayjs';
import Downloads from "@/api/Downloads.js";
import Tooltip from '@/components/ui/Tooltip.vue';
import ChooseData from '@/components/general/dialogs/ChooseDate.vue';
import ErrorSnackbar from '@/components/ui/ErrorSnackbar.vue';
import RejectionHistory from '@/components/diaries/dialogs/RejectionHistory'
import Loader from '@/components/ui/Loader.vue'
import PreviewDiary from '@/components/diaries/PreviewDiary.vue'




export default {
  components: {
    PreviewDiary,
    Loader,
    IconRemove,
    IconView,
    DialogSuccess,
    IconDownload,
    Tooltip,
    ChooseData,
    ErrorSnackbar,
    DialogConfirmation,
    RejectionHistory
  },
  watch: {
    'options': {
      immediate: false,
      handler () {
        if(this.$root.session.hasRole(['administrativo'])){
          if(this.changedOneTime == false){
            this.filter.status = 'FINISHED_APPROVAL'
            this.changedOneTime = true
          }
        }
        setTimeout(() => {this.searchDiaries()}, 10);
      },
      deep: true,
    },
  },
  beforeCreate(){
    document.title = "Report Lake - " + this.$t('menu.daily_parts_management');
  },
  data: () => ({
    previewDiary: {
      show: false,
      id: null
    },
    exportingDocument: false, 
    modalChooseData: false,
    changedOneTime: false,
    exportItems:[
      {
        'title': 'PDF'
      },
      {        
        'title': 'Excel'
      }
    ],
    expanded: [],
    items: [],
    total: 0,
    loading: false,
    error: {
      title: '',
      message: '',
      show:false,
    },
    searching: false,
    options: {},
    speedDial:false,
    filter: {
      code:null,
      work_id: null,
      commissioner_id:null,
      overseer_id:null,
      engineer_id:null,
      status: null,
    },
    status: [],
    works: [],
    commissioners:[],
    overseers:[],
    engineers:[],
    approved:false,
    checkApproval:{
      showModal: false,
      item: null,
      aprroval: null
    },
    showRejected:{
      show: false,
      item: null
    }
  }),
  async mounted(){

    if(!this.$root.session.hasPermission(["super", "diaries.read"])) {
      this.$router.push('/admin');
    }

    //this.fillBaseData();

    if(this.$route.params.code != undefined){
      this.filter.code = this.$route.params.code
      //this.searchDiaries()
    }else{
      this.filter.code = null
      //this.searchDiaries()
    }

    await Diary.listStatus().then(({data}) => {
      this.status = Object.keys(data).map(item => {return {id: item, name: data[item]}});
    });

    Work.list().then(({data}) => {
      this.works = data;
    });

    User.list().then(({data}) => {

      this.commissioners = data.filter(item => item.roles?.some(role => role.name == "encarregado"));

      this.overseers = data.filter(item => item.roles?.some(role => role.name == "maquinista"));

      this.engineers = data.filter(item => item.roles?.some(role => role.name == "dto"));
    });
  },
  methods:{
    showRejectedHistory(item){
      this.showRejected.item = item
      this.showRejected.show = true
    },
    async confirmExport(d1, d2, type, work){
      this.exportingDocument = true
      if(work == null){
        this.error.title = this.$t('diaries.missing_data')
            this.error.message = this.$t('diaries.filling_missing')
            this.error.show = true
            return
      }
      let data ={
        dataInicial: d1,
        dataFinal: d2,
        type: type,
        work: work
      }

      await Export.exportDiaries(data)
          .then((resp) => {
            if(resp.data.url == null){
              this.error.message = this.$t('diaries.no_daily_parts')
              this.error.show = true
              this.exportingDocument = false
              return;
            }
            window.open(resp.data.url, '_blank')
            Export.delete( resp.data.path)
              .then(() => {
                this.exportingDocument = false
              });
          });

    },
    checkIfApproved(i){
      if(i.status == "FINISHED_APPROVAL")
        return true
        
      return false
    },
    exportDiary(i, type){
      let data = {
        type: type
      }
      Export.exportDiary(i.id, data)
          .then((resp) => {
            window.open(resp.data.url, '_blank')
            Export.delete(resp.data.path)
              .then(() => {
                
              });
          });
    },
    row_classes(i){
      if(i.readed == true)
        return '';
    },
    async markDiaryReaded(i){
      await Diary.markRead(i.id, this.$root.session.id)
          .then(() => {
              i.readed = true
            });
    },
    async downloadImages(i){
      await Downloads.get(i.id)
        .then((response) => {
          window.open(response.data, '_blank');
        });

      await Downloads.delete(i.id)
        .then(() => {
          
        });


        //\Route::name("admin.download.delete")->get("images/{id}". "Delete");
    },
    getDateHour(d){
      let date = new Date(d)

      var formatOptions = { 
        day:    '2-digit', 
        month:  '2-digit', 
        year:   'numeric',
        hour:   '2-digit', 
        minute: '2-digit',
        hour12: false 
      };

      return date.toLocaleDateString('pt-PT', formatOptions);
    },
    lastUpdateString(i, v){
      if(i.user_edited == null){
        return "-"
      }
      if(v == 1)
        return i.user_edited.name + ' em ' + i.updated_at.split('T')[0] 
      else return i.updated_at.split('T')[0] 
    },
    getPossibleApprovals(item){
      
      let approvals = [];

      for(let approval in item.approvals){

        let auxApproval = item.approvals[approval];

        if(this.$root.session.hasRole(["super", approval]) && auxApproval.approved_at == null){

          approvals.push(approval);
        }
      }

      return approvals;
    },
    getTableDate(date) {
      return date != null ? dayjs(date).toDate().toLocaleDateString() : "-";
    },
    fillBaseData() {

      if(localStorage["diaries-" + this.$root.session.id] != undefined){

        let data = JSON.parse(localStorage["diaries-" + this.$root.session.id]);

        this.filter = data.filter;

        this.options = data.options;
      }
    },
    searchDiaries(event){
      if(!!event && event.type == 'submit'){
        this.options.page = 1;
      }

      this.loading = true;

      let filter = {...this.filter};

      let request = {
        sortBy: this.options.sortBy,
        sortDesc: this.options.sortDesc,
        page: this.options.page,
        limit: this.options.itemsPerPage,
      };
    
      Object.assign(request, filter);

      localStorage["diaries-" + this.$root.session.id] = JSON.stringify({
        filter: this.filter,
        options: this.options,
      });

      Diary.search(request).then(response => {

        let data = response.data;

        this.total = data.total;

        this.items = data.data.map((item) => {

          this.searching = false;

          return item;
        });

        this.loading = false;

      });
    },
    resetDiaries()
    {
      this.filter = {
        code:null,
        work_id: null,
        commissioner_id:null,
        overseer_id:null,
        engineer_id:null,
        status: null,
      }
      this.searchDiaries();
    },
    viewDiary(item){
      let domain = '/' + this.$session.get('domain')
      this.$router.push(domain + '/admin/diaries/' + item.id);
    },
    deleteDiary(item){
      Diary.delete(item.id)
        .then(() => {
          this.searchDiaries();
        });
    },
    confirmApprove(item, approval){
      this.checkApproval.item = item
      this.checkApproval.approval = approval

      this.checkApproval.showModal = true
    },
    async approve(){
      let item = this.checkApproval.item
      let approval = this.checkApproval.approval
      let parent = this
      await Diary.approve(item.id, approval)
        .then(() => {
          this.searchDiaries();
          parent.checkApproval.showModal = false

          this.approved = true;

        });
    },
    getWorkKey(id, key){
      let work = this.works.find(i => i.id == id);

      return work == undefined ? "---" : work[key];
    }
  },
  computed: {
    headers(){
      let he = [
        {
          text: '',
          sortable: true,
          value: 'read',
        },
        {
          text: this.$t('globals.code'),
          sortable: true,
          value: 'code',
        },
        {
          text: this.$t('globals.work'),
          sortable: true,
          value: 'work',
        },
        {
          text: this.$t('diaries.approval'),
          sortable: true,
          align: 'center',
          width: '120px',
          value: 'status',
        },
        {
          text: this.$t('globals.data'),
          sortable: true,
          value: 'date',
        },
        { 
          text: this.$t('globals.options'), 
          value: 'actions', 
          width: '200px',
          sortable: false 
        },
        { text: '', value: 'data-table-expand' },
      ]
      return he
    },
    tableFooter(){
      let t = this.$t("globals.lines_datatable")
      let a = [5, 10, 15, 20];
      return {
        'items-per-page-options': a,
        'items-per-page-text': t
      }
    }, 
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.daily_parts_management'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    },
    width () {
        if(window.innerWidth <= 1366){
          return 150
        }
        return 250
      }
  }
};
</script>